// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"Ga0a620","title":"G4f0f86","addressSubTitle":"Ga1f977","changeAddress":"G27712b","mobileAddressesList":"G37a593"};